import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fade from '@material-ui/core/Fade';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import SelectedItemIcon from '@material-ui/icons/CancelTwoTone';

import red from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/pink';
import purple from '@material-ui/core/colors/purple';
import deepPurple from '@material-ui/core/colors/deepPurple';
import indigo from '@material-ui/core/colors/indigo';
import blue from '@material-ui/core/colors/blue';
import lightBlue from '@material-ui/core/colors/lightBlue';
import cyan from '@material-ui/core/colors/cyan';
import teal from '@material-ui/core/colors/teal';
import green from '@material-ui/core/colors/green';
import lightGreen from '@material-ui/core/colors/lightGreen';
import lime from '@material-ui/core/colors/lime';
import yellow from '@material-ui/core/colors/yellow';
import amber from '@material-ui/core/colors/amber';
import orange from '@material-ui/core/colors/orange';
import deepOrange from '@material-ui/core/colors/deepOrange';
import brown from '@material-ui/core/colors/brown';
import grey from '@material-ui/core/colors/grey';
import blueGrey from '@material-ui/core/colors/blueGrey';

const styles = theme => {
  const shade = theme.palette.type === 'dark' ? 900 : 200;
  return ({
    avatar: {
      color: theme.palette.text.primary,
    },
    red: {
      backgroundColor: red[shade],
    },
    pink: {
      backgroundColor: pink[shade],
    },
    purple: {
      backgroundColor: purple[shade],
    },
    deepPurple: {
      backgroundColor: deepPurple[shade],
    },
    indigo: {
      backgroundColor: indigo[shade],
    },
    blue: {
      backgroundColor: blue[shade],
    },
    lightBlue: {
      backgroundColor: lightBlue[shade],
    },
    cyan: {
      backgroundColor: cyan[shade],
    },
    teal: {
      backgroundColor: teal[shade],
    },
    green: {
      backgroundColor: green[shade],
    },
    lightGreen: {
      backgroundColor: lightGreen[shade],
    },
    lime: {
      backgroundColor: lime[shade],
    },
    yellow: {
      backgroundColor: yellow[shade],
    },
    amber: {
      backgroundColor: amber[shade],
    },
    orange: {
      backgroundColor: orange[shade],
    },
    deepOrange: {
      backgroundColor: deepOrange[shade],
    },
    brown: {
      backgroundColor: brown[shade],
    },
    grey: {
      backgroundColor: grey[shade],
    },
    blueGrey: {
      backgroundColor: blueGrey[shade],
    },
    margin: {
      margin: '0 auto',
    },
  });
};

const ModelIconType = (title) => {
  try {
    return title.substr(0, 1).toUpperCase();
  } catch (e) {
    return 'D';
  }
};

const SelectableAvatar = (props) => {
  const {
    classes, children, id, selected, title, ...others
  } = props;
  const icon = ModelIconType(title);
  const colors = Object.values(classes);
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onChange(e);
  };

  if (selected) {
    return (
      <Avatar onClick={handleClick} {...others}>
        <IconButton>
          <Fade in={selected}>
            <SelectedItemIcon />
          </Fade>
        </IconButton>
      </Avatar>
    );
  }
  const avatarClasses = classNames(classes.avatar, colors[(id * 31) % colors.length], classes.margin);
  return (
    <Avatar
      {...others}
      onClick={handleClick}
      className={avatarClasses}
    >
      <IconButton color="inherit">
        {icon}
      </IconButton>
    </Avatar>
  );
};

SelectableAvatar.defaultProps = {
  selected: false,
  children: null,
};

SelectableAvatar.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object),
  onChange: PropTypes.instanceOf(Function).isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  selected: PropTypes.bool,
};

export default withStyles(styles)(SelectableAvatar);
